import { useDashboardDomainContext } from "../../../DashboardDomainProvider";
import { DashMessage } from "./DashMessage";

export const NoPagesMessage = () => {
  const { switchMode } = useDashboardDomainContext();

  return (
    <DashMessage
      icon={"page"}
      title={"No Pages Yet"}
      description={"Add the first page to begin shaping this dashboard."}
      buttonText={"Design Mode"}
      onClick={() => switchMode("design")}
    />
  );
};
